// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetTokenMicrosoftRequestModel from '../../model/get-token-microsoft-request-model';
import GetTokenMicrosoftRequestDTO from '../dto/get-token-microsoft-request-dto';
import dtoSchema from '../schemas/get-token-microsoft-request-schema';

export default abstract class GetTokenMicrosoftRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetTokenMicrosoftRequestDTO>) {
    super();
    if (data) {
      this.userName = data.userName ?? undefined;
      this.password = data.password ?? undefined;
      this.shareId = data.shareId ?? undefined;
    }
  }
  /**
  */
  userName?: string;
  /**
  */
  password?: string;
  /**
  */
  shareId?: string;

  static toModel(dto: DeepPartial<GetTokenMicrosoftRequestDTO>): GetTokenMicrosoftRequestModel;
  static toModel(dto: DeepPartial<GetTokenMicrosoftRequestDTO> | undefined | null): GetTokenMicrosoftRequestModel | undefined;
  static toModel(dto: DeepPartial<GetTokenMicrosoftRequestDTO> | undefined | null): GetTokenMicrosoftRequestModel | undefined {
    return dto ? new GetTokenMicrosoftRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetTokenMicrosoftRequestModel> | GetTokenMicrosoftRequestModel): GetTokenMicrosoftRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userName: unwrapped.userName,
      password: unwrapped.password,
      shareId: unwrapped.shareId,
    } as GetTokenMicrosoftRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetTokenMicrosoftRequestModel, can not map to GetTokenMicrosoftRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
